<div class="pageContainer refreshed-ui">
    <div class="spd-wrapper">
        <div class="sp-breadcrumb-nav-bar" >
            <a  data-id="solution-participation-details" routerLink="/solution-participation-details" [queryParams]="{tab: 'solution-group-view'}" class="link-blue">
                Solution Participation - Solution Group View
            </a>
            <div class="chevron"><img src="assets/chevron-right.svg" alt="chevron-right" /></div>
            <a  data-id="solution-participation-groupBy" class="last-breadcrumb link-blue" >
                Product Details
            </a>
        </div>

        <!-- Tabs section -->
        <section class="tabs-container">
            <div class="sg-tab hover-pointer tabSelected" data-id="usage-locations-tab">
                Products Ordered ({{productsCount}})
            </div>
        </section>

        <div class="search-block">
            <div class="search-box">
               <img width = "15" src="assets/gray-search-icon.png" class="search-icon" (click)="searchProduct()">
                <input
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearchInputChange()"
                    (focus)="onSearchFocus()"
                    (blur)="onSearchBlur()"
                    (keyup.enter)="searchProduct()"
                    placeholder="Search Products"
                    id="userInput"
                >
                <img src="assets/clear-icon.svg" id="clear" alt="clear-icon" class="clear-search" (click)="clear()">
            </div>
            <mat-chip-listbox id="selected-filter-list">
                <mat-chip-option
                        *ngFor="let filterChip of getAdvancedFilterChips()"
                        class="advanced-filters-chip-list"
                        disabled>
                        {{ filterChip }}
                </mat-chip-option>
                </mat-chip-listbox>
            <div class="exporttable-btn" (click)="exportAllToExcel()">
                <div class="export-icon">
                 <span *ngIf="!isDownloadingFile">
                    <img src="assets/export-table-icon.svg" alt="export-table-icon" />
                </span>
                <span *ngIf="isDownloadingFile">
                    <span class="loader-sm"></span>
                </span>
                </div>
                <span>Export Table</span>
            </div>
        </div>

        <div class="search-pagination-row neptune-advanced-filters" id="pagination-row">
            <loader [size]="'small'" *ngIf="displayLoaderForFilterData"></loader>
            <div id="sol-part-product-advanced-filters" *ngIf="!displayLoaderForFilterData">
                <advanced-filters
                    [advancedFilterData]="advancedFilterData"
                    [excludeKeys]="excludeKeys"
                    [pageScope] = "'Solution participation Product Details'"
                    [selectedAdvancedFilters] = "productSelectedAdvancedFilters"
                    [filterGroupings]="filterGroupings"
                    (selectedFilters) = "onSelectedFiltersChange($event)"
                    [(toggleBody)]="toggleAdvancedFilterSelection"
                    [useRefreshedUi]="true"
                ></advanced-filters>
                <advanced-filters-selection
                    [advancedFilterData]="advancedFilterData"
                    [excludeKeys]="excludeKeys"
                    [pageScope]="'Solution participation Product Details'"
                    [selectedAdvancedFilters]="productSelectedAdvancedFilters"
                    (selectedFilters)="onSelectedFiltersChange($event)"
                    [filterGroupings]="filterGroupings"
                    [(toggleBody)]="toggleAdvancedFilterSelection"
                >
                </advanced-filters-selection>
            </div>
            <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]" [length]="productsCount"
                (page)="onPageChange($event)" aria-label="Select page"></mat-paginator>
        </div>

        <!-- Product Details Table -->
        <section class="products-details-table" *ngIf="!isLoading; else loader" id="products-details-table">
            <!-- Table header section -->
            <div class="header-box">
                <div class="product common-p">
                    Product Ordered
                    <span class="sort-arrow"  data-id="sort-arrow-location" (click)="toggleSortDirection('product')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['product'] == 'asc', 'down': sortDirections['product'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="accountNumber common-p">Account Info</div>
                <div class="sales common-p">
                    Product Sales Summary
                    <span class="sort-arrow" data-id="sort-arrow-sales" (click)="toggleSortDirection('sales')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['sales'] == 'asc', 'down': sortDirections['sales'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="cases common-p">
                    Cases
                    <span class="sort-arrow" data-id="sort-arrow-cases"  (click)="toggleSortDirection('cases')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['cases'] == 'asc', 'down': sortDirections['cases'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="exportall-checkbox common-p">
                    <mat-checkbox color="primary" (change)="selectAllRows()" [checked]="allRowsSelected">Export All</mat-checkbox>
                </div>
            </div>

            <ng-container *ngIf="groupedData?.products?.length && !productNotFound; else noData">
                <ng-container *ngFor="let product of groupedDataPaginated; let i = index;">
                    <div class="products-table-row"  [id]="'products-table-row-' + i"
                        [ngClass]="{'summary-row': product.totalAccountCount > 1}"
                        (click)="productDrillClicked(product, $event,i)">
                        <!-- Product block -->
                        <div class="product-block p-20">
                            <div class="text-700">{{product?.productName}}</div>
                            <div><span class="sku-text">SKU: </span>{{product?.productCode}}</div>
                        </div>
                        <!-- Account Info, Sales and Cases Block -->
                        <ng-container [ngSwitch]="product?.totalAccountCount">
                            <!-- Locations Length == 0 -->
                            <ng-container *ngSwitchCase="0">
                                <div class="account-block p-20">N/A</div>
                                <div class="sales-block p-20">N/A</div>
                                <div class="cases-block p-20">N/A</div>
                            </ng-container>

                            <!-- Locations Length == 1 -->
                            <ng-container *ngSwitchCase="1">
                                <div class="account-block p-20">
                                    {{ product.accountInfo[0].accountNumber}}
                                    <div class="location-name">{{product.accountInfo[0].accountName | capitalize}}</div>
                                </div>
                                <div class="sales-block p-20">
                                    <p class="sales-amount">{{product.totalSalesAmount.value | currency:currencyCode:'symbol':'1.0-0'}}</p>
                                </div>
                                <div class="cases-block p-20">
                                    <p class="cases-amount">{{product.totalSalesQuantity | number}}</p>
                                </div>
                            </ng-container>

                            <!-- Locations Length > 1 -->
                            <ng-container *ngSwitchDefault>
                                <div class="account-block p-20">
                                    <div class="account-box">
                                        <div class="count"> {{product?.totalAccountCount}} </div>
                                        <div class="sub-text">Accounts</div>
                                    </div>
                                </div>
                                <div class="sales-block p-20">
                                    <p class="total-sales total"><span class="text-gray">Total Sales</span> - {{product.totalSalesAmount.value | currency:currencyCode:'symbol':'1.0-0'}}</p>
                                </div>
                                <div class="cases-block p-20">
                                    <p class="total-cases total"><span class="text-gray">Total Cases</span> - {{product.totalSalesQuantity | number}}</p>
                                </div>
                            </ng-container>
                        </ng-container>

                        <!-- Export button block -->
                        <div class="export-block p-20">
                            <div class="export-checkbox">
                                <mat-checkbox color="primary" [checked]="rowSelection[(paginator.pageIndex * paginator.pageSize) + i]"
                                #checkBox (change)="onCheckboxChange(checkBox,product,i)">Export</mat-checkbox>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </section>

        <!-- Display 'No Data' when there are no locations on load -->
        <ng-template #noData>
            <div *ngIf="!productNotFound" class="Loader">
                No Data
            </div>
        </ng-template>

        <!-- Display 'Product not found' when search results are empty -->
        <ng-template [ngIf]="(productNotFound && !this.isLoading)">
            <div class="not-found">
                Product not found.
            </div>
        </ng-template>

        <ng-template #loader>
            <div class="Loader">
                Loading...
                <loader></loader>
            </div>
        </ng-template>
</div>
